import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICandidatePost } from '../Models/icandidate-post';
import { ICenter } from '../Models/icenter';
import { Ieducation } from '../Models/ieducation';
import { Ipost } from '../Models/ipost';
import { Iprofessional } from '../Models/Iprofessional';
import { IRegister } from '../Models/IRegister';
import { ITestTable } from '../Models/test-table';
import { DataService } from '../services/data.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { DownloadService } from '../services/download.service';
import { PostService } from '../services/post.service';
import { CenterService } from '../services/center.service';
import { QuotaService } from '../services/quota.service';
import { ProfileService } from '../services/profile.service';
import { ProjectsService } from '../services/projects.service';
import { FeeChallanService } from '../services/fee-challan.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  postList: Ipost[] = [];
  projectName = {} as ITestTable;
  selectedProject = {} as ITestTable;
  selectedPost = {} as Ipost;
  loading = true;
  personalData = {} as IRegister;
  appliedPost = {} as Ipost;
  applied = {} as ICandidatePost;
  center = {} as ICenter;
  educationList: Ieducation[] = [];
  experienceList: Iprofessional[] = [];
  subs: Subscription[] = [];
  message = '';
  isProcessing = false;
  isPicAvailable = false;
  isDataLoaded = false;
  base64String = '';

  constructor(private profile: ProfileService, private project: ProjectsService, private post: PostService,
    private snakBar: DataService, private router: Router,
    private download: DownloadService, private routerParam: ActivatedRoute,
    private centerService: CenterService, private quotaService: QuotaService,
    private feeChallan: FeeChallanService) { }

  ngOnInit() {
    const decryptedID = this.snakBar.decryptID(this.routerParam.snapshot.params['id']);

    this.loadData(decryptedID);
  }

  loadData(id: string) {
    this.isProcessing = true;
    if (!navigator.onLine) {
      this.snakBar.onError('No internet Connection: Please check your internet connection');
      this.isProcessing = false;
      return;
    }
    this.isPicAvailable = false;
    this.isDataLoaded = false;
    this.subs.push(this.profile.getImage().subscribe(res => {
      if (res) {
        this.base64String = btoa(
          new Uint8Array(res)
            .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
      }
    },
      err => {
        if (err.status === 404) {
          this.isPicAvailable = false;
          this.isProcessing = false;
        }
      }));
    this.subs.push(this.download.getData(id).subscribe(res => {
      if (res.code === '0000') {
        this.loading = false;
        const p = res.data.personal || {};
        this.personalData = {
          name: p.name || p.fullName || p.FullName || '',
          father_Name: p.father_Name || p.FatherName || p.fatherName || '',
          cnic: p.cnic || p.CNIC || '',
          contact: p.contact || p.phone || p.PhoneNumber || '',
          password: p.password || '',
          province: p.province || p.Province || '',
          district: p.district || p.District || '',
          city: p.city || p.City || '',
          address: p.address || p.Address || '',
          dob: p.dob || p.dateOfBirth || p.DateOfBirth || null,
          gender: p.gender || p.Gender || '',
          religion: p.religion || p.Religion || '',
          disable: p.disable || p.isDisabled || p.Disabled || '',
          orphan: p.orphan || '',
          govtServant: p.govtServant || p.isGovtServant || '',
          identity_Number: p.identity_Number || p.registrationNumber || p.RegistrationNumber || '',
          email: p.email || p.Email || '',
          currentOccupation: p.currentOccupation || p.CurrentOccupation || ''
        } as any;

        const post = res.data.post || {};
        this.appliedPost = {
          id: post.id || post.ID || '',
          name: post.name || post.Title || post.postName || '',
          postCode: post.postCode || post.PostCode || '',
          applicationDate: post.applicationDate || post.ApplicationDate || '',
          fee: post.fee || post.Fee || 0,
          status: post.status || post.Status || '',
          department: post.department || post.Department || '',
          category: post.category || post.Category || ''
        } as any;

        const applied = res.data.applied || {};
        this.applied = {
          id: applied.id || applied.ID || '',
          test_ID: applied.test_ID || applied.TestId || '',
          post_ID: applied.post_ID || applied.PostId || '',
          quota: applied.quota || applied.Quota || '',
          center_ID: applied.center_ID || applied.CenterId || '',
          c1: applied.c1 || '',
          c2: applied.c2 || '',
          c3: applied.c3 || '',
          c4: applied.c4 || '',
          lastDate: applied.lastDate || '',
          challan_No: applied.challan_No || applied.ChallanNo || '',
          serviceDuration: applied.serviceDuration || '',
          joiningDate: applied.joiningDate || '',
          nOCAttached: applied.nOCAttached || '',
          aF_Unit: applied.aF_Unit || '',
          aF_EnrolmentDate: applied.aF_EnrolmentDate || '',
          aF_DischaregRank: applied.aF_DischaregRank || '',
          aF_DischaregDate: applied.aF_DischaregDate || '',
          aF_PensionerStatus: applied.aF_PensionerStatus || '',
          aF_ServicesDuration: applied.aF_ServicesDuration || '',
          aF_DischargeReason: applied.aF_DischargeReason || '',
          aF_CharacterAssessed: applied.aF_CharacterAssessed || '',
          aF_ArmyQualification: applied.aF_ArmyQualification || '',
          contact2: applied.contact2 || '',
          currectPost: applied.currectPost || ''
        } as any;

        this.educationList = res.data.education || [];
        this.experienceList = res.data.experience || [];
        const center = res.data.center || {};
        this.center = {
          id: center.id || center.ID || '',
          city: center.city || center.City || center.name || center.Name || '',
          active: center.active || center.Active || '',
          aid: center.aid || center.AID || ''
        } as any;
        this.projectName = res.data.project || {};
        this.isDataLoaded = true;
        if (!this.personalData.name || !this.personalData.cnic) {
          this.fillMissingFromProfile();
        }
        this.ensurePostCenterQuota();
        // No auto-download; user triggers via button on the form page
      } else if (res.code === '1001') {
        this.loading = false;
        this.router.navigate(['/']);
      } else {
        this.message = res.message;
        this.isProcessing = false;
        this.snakBar.onError(res.message);
        this.fillMissingFromProfile();
        this.isDataLoaded = true;
        this.resolveAppliedAndReload(id);
      }
    }));

  }

  private resolveAppliedAndReload(postId: string) {
    this.subs.push(this.feeChallan.getAppliedPosts().subscribe(r => {
      if (r && r.code === '0000' && Array.isArray(r.data)) {
        const match = r.data.find(p => p.postCode === postId || p.title === this.appliedPost.name);
        if (match && match.id) {
          const id = match.id.toString();
          this.subs.push(this.download.getData(id).subscribe(res => {
            if (res && res.code === '0000') {
              const p = res.data.personal || {};
              this.personalData = {
                name: p.name || p.fullName || p.FullName || '',
                father_Name: p.father_Name || p.FatherName || p.fatherName || '',
                cnic: p.cnic || p.CNIC || '',
                contact: p.contact || p.phone || p.PhoneNumber || '',
                password: p.password || '',
                province: p.province || p.Province || '',
                district: p.district || p.District || '',
                city: p.city || p.City || '',
                address: p.address || p.Address || '',
                dob: p.dob || p.dateOfBirth || p.DateOfBirth || null,
                gender: p.gender || p.Gender || '',
                religion: p.religion || p.Religion || '',
                disable: p.disable || p.isDisabled || p.Disabled || '',
                orphan: p.orphan || '',
                govtServant: p.govtServant || p.isGovtServant || '',
                identity_Number: p.identity_Number || p.registrationNumber || p.RegistrationNumber || '',
                email: p.email || p.Email || '',
                currentOccupation: p.currentOccupation || p.CurrentOccupation || ''
              } as any;
              const post = res.data.post || {};
              this.appliedPost = {
                id: post.id || post.ID || '',
                name: post.name || post.Title || post.postName || '',
              } as any;
              const applied = res.data.applied || {};
              this.applied = {
                id: applied.id || applied.ID || '',
                test_ID: applied.test_ID || applied.TestId || '',
                post_ID: applied.post_ID || applied.PostId || '',
                quota: applied.quota || applied.Quota || ''
              } as any;
              const center = res.data.center || {};
              this.center = {
                id: center.id || center.ID || '',
                city: center.city || center.City || center.name || center.Name || '',
                active: center.active || center.Active || '',
                aid: center.aid || center.AID || ''
              } as any;
            }
          }));
        }
      }
    }));
  }

  private ensurePostCenterQuota() {
    if ((!this.center || !this.center.city) && this.applied && this.applied.center_ID && this.applied.test_ID) {
      this.subs.push(this.centerService.GetCenter(this.applied.test_ID).subscribe(res => {
        if (res && res.code === '0000' && Array.isArray(res.data)) {
          const cid = Number(this.applied.center_ID as any);
          const m = res.data.find((x: any) => {
            const xid = Number((x.aid || x.AID || x.id || x.ID) as any);
            return !isNaN(cid) && xid === cid;
          });
          if (m) {
            this.center = {
              id: m.id || m.ID || '',
              city: m.city || m.City || m.name || m.Name || '',
              active: m.active || m.Active || '',
              aid: m.aid || m.AID || ''
            } as any;
          }
        }
      }));
    }
    if ((!this.appliedPost || !this.appliedPost.name) && this.applied && this.applied.test_ID && this.applied.post_ID) {
      this.subs.push(this.post.GetPosts(this.applied.test_ID).subscribe(res => {
        if (res && res.code === '0000' && Array.isArray(res.data)) {
          const match = res.data.find(p => p.id === this.applied.post_ID || p.ID === this.applied.post_ID);
          if (match) {
            this.appliedPost = {
              id: match.id || match.ID || '',
              name: match.name || match.postName || match.Title || ''
            } as any;
          }
        }
      }));
    }
    if (!this.applied.quota) {
      this.applied.quota = this.applied.c1 || this.applied.c2 || this.applied.c3 || this.applied.c4 || 'Nill';
    }
  }

  private fillMissingFromProfile() {
    this.subs.push(this.profile.GetPersonalInfo().subscribe(r => {
      if (r && r.code === '0000' && r.data) {
        const p = r.data;
        this.personalData = {
          name: this.personalData.name || p.name || p.fullName || '',
          father_Name: this.personalData.father_Name || p.father_Name || p.FatherName || '',
          cnic: this.personalData.cnic || p.cnic || p.CNIC || '',
          contact: this.personalData.contact || p.contact || p.phoneNumber || '',
          password: this.personalData.password || '',
          province: this.personalData.province || p.province || '',
          district: this.personalData.district || p.district || '',
          city: this.personalData.city || p.city || '',
          address: this.personalData.address || p.address || '',
          dob: this.personalData.dob || p.dob || p.dateOfBirth || null,
          gender: this.personalData.gender || p.gender || '',
          religion: this.personalData.religion || p.religion || '',
          disable: this.personalData.disable || p.disable || '',
          orphan: this.personalData.orphan || '',
          govtServant: this.personalData.govtServant || '',
          identity_Number: this.personalData.identity_Number || p.identity_Number || p.registrationNumber || '',
          email: this.personalData.email || p.email || '',
          currentOccupation: this.personalData.currentOccupation || p.currentOccupation || ''
        } as any;
      }
    }));
  }

  private async downloadFormPDF() {
    try {
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const logo = await this.loadImageSafe('assets/images/qts-logo.png');
      const candImg = this.base64String ? await this.loadImageSafe('data:image/png;base64,' + this.base64String) : null;

      if (logo) doc.addImage(logo, 'PNG', 10, 10, 25, 20);
      if (candImg) doc.addImage(candImg, 'PNG', pageWidth - 35, 10, 25, 20);

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      const title = this.projectName && this.projectName.name ? this.projectName.name : 'Application Form';
      doc.text(title, pageWidth / 2, 20, { align: 'center' });
      doc.setFontSize(11);
      if (this.personalData.identity_Number) {
        doc.text('Registration Number: ' + this.personalData.identity_Number, pageWidth / 2, 27, { align: 'center' });
      }

      const autoTable: any = (doc as any);
      const postColumns = [
        { title: 'Post Applied', dataKey: 'post' },
        { title: '', dataKey: 'fecha' },
        { title: '', dataKey: 'fecha1' },
        { title: '', dataKey: 'fecha2' }
      ];
      const postData = [
        { post: 'Test Center:', fecha: this.center && this.center.city ? this.center.city : 'Nill' },
        { post: 'Post:', fecha: this.appliedPost.name },
        { post: 'Quota:', fecha: this.applied.quota }
      ];
      autoTable.autoTable(postColumns, postData, { margin: { top: 40 } });

      const personalColumns = [
        { title: 'Personal Information', dataKey: 'personal' },
        { title: '', dataKey: 'fecha' },
        { title: '', dataKey: 'fecha1' },
        { title: '', dataKey: 'fecha2' }
      ];
      const personalData = [
        { personal: 'Name:', fecha: this.personalData.name },
        { personal: 'Father Name:', fecha: this.personalData.father_Name },
        { personal: 'CNIC:', fecha: this.personalData.cnic },
        { personal: 'Contact:', fecha: this.personalData.contact },
        { personal: 'Gender:', fecha: this.personalData.gender },
        { personal: 'Religion:', fecha: this.personalData.religion },
        { personal: 'City:', fecha: this.personalData.city || 'Nill' },
        { personal: 'Province:', fecha: this.personalData.province },
        { personal: 'District:', fecha: this.personalData.district || 'Not Entered' },
        { personal: 'Disable:', fecha: this.personalData.disable || 'Nill' },
        { personal: 'Address:', fecha: this.personalData.address }
      ];
      autoTable.autoTable(personalColumns, personalData);

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      if (isIOS) {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        const w = window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 10000);
        if (!w) doc.save('Application Form.pdf');
      } else {
        doc.save('Application Form.pdf');
      }
    } catch { }
  }

  onDownload() {
    this.downloadFormDOMPDF();
  }

  private loadImageSafe(src: string): Promise<HTMLImageElement | null> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = src;
    });
  }

  private async downloadFormDOMPDF() {
    try {
      const root = document.getElementById('FormAreaDiv');
      if (!root) { this.downloadFormPDF(); return; }
      const h2c: any = (window as any).html2canvas;
      if (!h2c) { this.downloadFormPDF(); return; }
      const dpr = (window as any).devicePixelRatio || 1;
      const targetDpiScale = (600 / 96) * dpr;
      const scale = Math.min(8, Math.max(6, targetDpiScale));
      const canvas: HTMLCanvasElement = await h2c(root, {
        scale,
        useCORS: true,
        allowTaint: true,
        background: '#ffffff',
        logging: false,
        scrollY: -window.scrollY,
        windowWidth: root.scrollWidth,
        windowHeight: root.scrollHeight,
        onclone: (doc: Document) => {
          const style = doc.createElement('style');
          style.textContent = `.print-btn{display:none!important}`;
          doc.head.appendChild(style);
        }
      });

      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 5;
      const usableW = pageWidth - margin * 2;

      const imgWidth = usableW;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = margin;

      const dataURL = canvas.toDataURL('image/png');
      doc.addImage(dataURL, 'PNG', margin, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        doc.addPage();
        position = margin - (imgHeight - heightLeft);
        doc.addImage(dataURL, 'PNG', margin, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      doc.save('Application Form.pdf');
    } catch {
      this.downloadFormPDF();
    }
  }
}
